
export const API_DISALLOWED_FILETYPES = ['.js', '.css', '.xml', '.png', '.jpeg', '.jpg']
